import { useLocation, useParams } from "react-router-dom";
import { useFeatureContext } from "../../../../context/Feature";
import useGetOrderItemInrixVolumeParams from "../../../map/views/OrderItem/InrixVolumes/controls/GetOrderItemInrixVolumeParams";
import { parseInrixVolumeFeature } from "../../../map/views/OrderItem/InrixVolumes/models/InrixVolumeFeature";
import InrixVolumeSidebarHeader from "./InrixVolumeSidebarHeader";
import SegmentDayPicker from "./SegmentDayPicker";
import SegmentChart from "./SegmentChart";

const OrderItemInrixVolumesSidebar = () => {
  const { pathname } = useLocation();
  const { selectedFeatures } = useFeatureContext();
  const { timePeriod, timeSegment, timeIndex } =
    useGetOrderItemInrixVolumeParams();

  const { layer } = useParams();

  const isOrderItemInrixVolumesRoute =
    pathname.toLowerCase().includes("orderitem") &&
    layer &&
    layer.toLowerCase().includes("inrix:volumes");

  if (!isOrderItemInrixVolumesRoute || selectedFeatures.length === 0) {
    return null;
  }

  const [feature] = selectedFeatures;
  const model = parseInrixVolumeFeature(feature);

  if (model === null) {
    return null;
  }

  return (
    <div className="p-3 w-100 h-100 d-flex flex-column">
      <InrixVolumeSidebarHeader
        model={model}
        timePeriod={timePeriod}
        timeSegment={timeSegment}
        timeIndex={timeIndex}
      />
      <SegmentDayPicker />
      <SegmentChart feature={model} />
    </div>
  );
};

export default OrderItemInrixVolumesSidebar;
